import qs from 'qs'

export const queryEditionsPage = () => {
  const query = qs.stringify(
    {
      fields: ['title'],
      populate: {
        ...queryFragmentSingleTypeDefault
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `editions-page?${query}`
}
